var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doc-collection-wrap"},[_c('sidebar',{on:{"updateHtml":_vm.updateHtml}}),_c('preview',{attrs:{"html":_vm.html}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }